import axios from '@/utils/axios'
const api = {
    auth: '/company/merchant/users/auth',
    login: '/company/merchant/users/login',
    invite: '/api/users/inviteList',
    detail: '/api/users'
}
/**
 * auth
 * @returns {Promise<any>}
 */
export function fetchAuth (taskApplyId) {
    return new Promise((resolve, reject) => {
        axios.get(api.auth, { params: { taskApplyId } })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 系统生成的优惠券查看是否有核销权限
export function fetchCheckMerchant (activitySendId) {
    return new Promise((resolve, reject) => {
        axios.get('/company/activity/checkMerchantId', { params: { activitySendId } })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function fetchInviteList (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.invite, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function fetchDetail (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.detail, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * login
 * @returns {Promise<any>}
 */
export function fetchLogin (params) {
    return new Promise((resolve, reject) => {
        axios.post(api.login, { ...params })
            .then(response => {
                if (typeof response.data === 'undefined') {
                    resolve(response)
                } else {
                    resolve(response.data)
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}
